import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ItensMenu from "./ItensMenu";
import "./Sidebar.css";
import SidebarFooter from "./SidebarFooter";
import SidebarHeader from "./SidebarHeader";

const Sidebar = (props) => {
  const { close } = props;
  const location = useLocation();
  const isDocumentsSectionActive = location.pathname.startsWith("/documentos");
  const [documentsMenuOpen, setDocumentsMenuOpen] = useState(isDocumentsSectionActive);

  useEffect(() => {
    if (isDocumentsSectionActive) {
      setDocumentsMenuOpen(true);
    }
  }, [isDocumentsSectionActive]);

  return (
    <aside className={`sidebar ${close ? "collapsed" : ""}`} id="sidebar">
      <SidebarHeader />

      <nav className="sidebar-menu">
        <ItensMenu active={props.dashboardActive} icone={"\uD83C\uDFE0"} nome="Dashboard" link="/dashboard" />
        <ItensMenu active={props.storeActive} icone={"\uD83D\uDED2"} nome="Store" link="/store" />
        <ItensMenu
          active={props.dadosBancariosActive}
          icone={"\uD83C\uDFE6"}
          nome="Dados bancarios"
          link="/dadosbancarios"
        />
        <ItensMenu icone={"\u2795"} nome="Cadastrar leads" link="/embreve" />
        <ItensMenu active={props.extratoActive} icone={"\uD83D\uDCC4"} nome="Extrato" link="/extrato" />

        <div className={`admin-menu-group ${isDocumentsSectionActive ? "active" : ""}`}>
          <button
            type="button"
            className={`admin-menu-trigger ${isDocumentsSectionActive ? "active" : ""}`}
            onClick={() => setDocumentsMenuOpen((current) => !current)}
          >
            <span className="menu-icon">{"\uD83D\uDCC1"}</span>
            <span className="menu-text">Materiais de apoio</span>
            <span className={`admin-menu-caret ${documentsMenuOpen ? "open" : ""}`}>{"\u25be"}</span>
          </button>

          {documentsMenuOpen ? (
            <div className="admin-submenu">
              <a
                href="/documentos/manual-operacoes"
                className={`admin-submenu-item ${props.manualOperacoesActive || ""}`}
              >
                <span className="menu-icon">{"\uD83D\uDCD6"}</span>
                <span className="menu-text">Manual de operacoes</span>
              </a>
              <a
                href="/documentos/portifolio-perfumaria"
                className={`admin-submenu-item ${props.portifolioPerfumariaActive || ""}`}
              >
                <span className="menu-icon">{"\uD83C\uDF3F"}</span>
                <span className="menu-text">Portifolio de perfumaria</span>
              </a>
              <a
                href="/documentos/apresentacoes"
                className={`admin-submenu-item ${props.presentationsActive || ""}`}
              >
                <span className="menu-icon">{"\uD83D\uDCFD\uFE0F"}</span>
                <span className="menu-text">Apresentações</span>
              </a>
              <a
                href="/documentos/maquinas"
                className={`admin-submenu-item ${props.machinesSupportActive || ""}`}
              >
                <span className="menu-icon">{"\u2699\uFE0F"}</span>
                <span className="menu-text">MÃ¡quinas</span>
              </a>
            </div>
          ) : null}
        </div>

        <ItensMenu active={props.ajudaActive} icone={"\u2753"} nome="Ajuda / FAQ" link="/ajuda" />
      </nav>

      <SidebarFooter />
    </aside>
  );
};

export default Sidebar;
